<template>
  <div class="login">
    <div class="header">
      手机验证码登录
      <img src="../../../assets/images/System/line.png" />
    </div>
    <div class="login-form">
      <van-cell-group>
        <div class="left-flag" @click="showPicker=true">
          <img :src="flag_src" alt="" />
          <span>{{"+"+area_code}}</span>
          <van-icon name="arrow-down" />
        </div>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <van-field
          v-model="formData.mobile"
          placeholder="请输入账号"
          clearable
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="formData.img_code"
          placeholder="请输入图形验证码"
          clearable
        />
        <img :src="image_code" @click="changeImgCode"/>
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="formData.code"
          placeholder="请输入短信验证码"
          clearable
        />
        <van-button @click="sendCode" class="code">{{
          sendTimeText
        }}</van-button>
      </van-cell-group>
      <!-- <button class="wxLogin" @click="wxLogin">微信登录</button> -->
      <button @click="Login" class="login-button" :disabled="disabled">登录</button>
    </div>
  </div>
</template>
<script>
import {
  SendCode,
  GetUserInfo,
  VascularLogin,
  BindMobile,
  countryPhoneCode,
  imgCode
} from "../../../config/interface.js";
import { Dialog,Toast } from "vant";

let codeTimer;
export default {
  data() {
    return {
      sendTimeText: "发送验证码",
      formData: {
        mobile: "",
        code: "",
        img_code:''
      },
      img_url:'',
      image_code:'',
      countdown: 60,
      isReSend: true, //能否再次点击发送验证码
      isBind: true,
      showPicker:false,
      disabled:false,
      area_code:'86',
      flag_src:require('../../../assets/images/System/flag/China.png'),
      timestamp:'',
      columns:[
        '中国',
        '中国香港',
        '中国澳门',
        '中国台湾',
        '新加坡',
        '英国',
        '美国',
        '加拿大',
        '希腊',
        '荷兰',
        '比利时',
        '法国',
        '西班牙',
        '爱尔兰',
        '瑞士',
        '德国'
      ],
      codes:{},
      flags:{
        '中国':require('../../../assets/images/System/flag/China.png'),
        '中国香港':require('../../../assets/images/System/flag/China.png'),
        '中国澳门':require('../../../assets/images/System/flag/China.png'),
        '中国台湾':require('../../../assets/images/System/flag/China.png'),
        '新加坡':require('../../../assets/images/System/flag/Singapore.png'),
        '英国':require('../../../assets/images/System/flag/UK.png'),
        '美国':require('../../../assets/images/System/flag/USA.png'),
        '加拿大':require('../../../assets/images/System/flag/Canada.png'),
        '希腊':require('../../../assets/images/System/flag/Greece.png'),
        '荷兰':require('../../../assets/images/System/flag/Holland.png'),
        '比利时':require('../../../assets/images/System/flag/Belgium.png'),
        '法国':require('../../../assets/images/System/flag/France.png'),
        '西班牙':require('../../../assets/images/System/flag/Spain.png'),
        '爱尔兰':require('../../../assets/images/System/flag/Ireland.png'),
        '瑞士':require('../../../assets/images/System/flag/Swit.png'),
        '德国':require('../../../assets/images/System/flag/Germany.png'),
      }
    };
  },
  created() {
    
  },
  mounted() {
    if(common.is_weixin){
      this.getPersonalUserInfo(); //微信登录需要授权 所以要获取用户信息判断是否授权
    }
    this.getImgCode()
    this.getCountryCode();
    
  },
  methods: {
    //区号
    getCountryCode(){
      const url = countryPhoneCode;
      const method = "POST";
      fetch(url, {}, method).then((res) => {
            if (res.code == 0) {
              let data=res.data;
              data.forEach(element => {
                this.codes[element.country_cn]=element.code;
              });

            }
      });

    },
    getImgCode(){
      const url = imgCode;
      const method = "GET";
      fetch(url, {}, method).then((res) => {
            if (res.code == 0) {
              console.log(res.data.base64_image)
              this.image_code = res.data.base64_image
            }
      });
    },
    //
    Login() {
      if (this.isBind == false) {
        Dialog.confirm({
          message: "确定将该微信绑定该手机号？",
        })
          .then(() => {
            if (this.verifyForm()) {
              Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '',
            });
              this.disabled=true;
              const url = BindMobile;
              const method = "POST";
              let params = {
                mobile: this.formData.mobile,
                msgcode: this.formData.code,
                code: this.formData.img_code,
                country_code:this.area_code
              };
              fetch(url, params, method).then((res) => {
                this.disabled=false;
                Toast.clear();
                if (res.code == 0) {
                  common.toast("登录成功", 1000, "success", () => {
                  localStorage.setItem("token", res.data.user_access_token);
                  this.setUserInfo(res.data.local_data);
                  });
                } else {
                  if (res.code == 901) {
                    Dialog.confirm({
                      message: "您的账号已在PC端注册过，是否强制合并账号？",
                    })
                      .then(() => {
                        Toast.loading({
                            duration: 0,
                            forbidClick: true,
                            message: '',
                        });
                        this.disabled=true;
                        const url = BindMobile;
                        const method = "POST";
                        let params = {
                          mobile: this.formData.mobile,
                          msgcode: this.formData.code,
                          code: this.formData.img_code,
                          country_code:this.area_code,
                          merge_account: 1,
                        };
                        fetch(url, params, method).then((res) => {
                          this.disabled=false;
                          Toast.clear();
                          if (res.code == 0) {
                            common.toast("登录成功", 1000, "success", () => {
                              localStorage.setItem("token",res.data.user_access_token);
                              this.setUserInfo(res.data.local_data);
                            });
                          } else {
                            common.toast( res && res.error_msg ? res.error_msg : "未知错误",1000,'fail',()=>{
                            })
                          }
                        });
                      })
                      .catch(() => {});
                  } else {
                    common.toast(
                      res && res.error_msg ? res.error_msg : "未知错误",
                      1000,
                      "fail",
                      () => {}
                    );
                  }
                }
              });
            }
          })
          .catch(() => {});
      } else {
        if (this.verifyForm()) {
          Toast.loading({
              duration: 0,
              forbidClick: true,
              message: '',
          });
          this.disabled=true;
          const url = VascularLogin;
          const method = "POST";
          let params = {
            mobile: this.formData.mobile,
            country_code:this.area_code,
            msgcode: this.formData.code,
            code: this.formData.img_code,
          };
          fetch(url, params, method).then((res) => {
            this.disabled=false;
            Toast.clear();
            if (res.code == 0) {
                common.toast("登录成功", 1000, "success", () => {
                localStorage.setItem("token", res.data.user_access_token);
                this.setUserInfo(res.data.local_data);
              });
            } else {
              common.toast( res && res.error_msg ? res.error_msg : "未知错误",1000,'fail',()=>{})
            }
          });
        }
      }
    },
    //验证手机号
    verifyMobile() {
      let mobile = this.formData.mobile;
      let reg=/^1[3456789]\d{9}$/
      if (mobile == "") {
        common.toast("请输入手机号", 1000);
      } else if (!reg.test(mobile) && this.area_code=='86') {
        common.toast("请输入正确手机号", 1000);
      } else if(this.formData.img_code == ''){
        common.toast("请输入图形验证码", 1000);
      }else {
        return true;
      }
      return false;
    },
    //区号选择
    onConfirm(value) {
      this.area_code = this.codes[value];
      this.flag_src=this.flags[value];
      this.showPicker = false;
    },
    //点击发送验证码
    sendCode() {
      if (this.isReSend && this.verifyMobile()) {
        this.getCode();
        this.isReSend = false;
      }
    },
    //看是否绑定手机号
    getPersonalUserInfo() {
      if (common.is_weixin()) {
        //微信端页面
        const url = GetUserInfo;
        let params = {};
        const method = "POST";
        fetch(url, params, method).then((res) => {
          if (res.code == 0) {
            let data = res.data;
            this.userInfo = JSON.stringify(data);
            localStorage.setItem("userInfo", JSON.stringify(data));
            this.$store.dispatch("storageUserInfo", data);
            if (data.mobile_status == 0) {
              this.isBind = false;
            }
          }
        });
      }
    },
    //得到验证码
    getCode(mobile) {
      this.sendTime();
      const url = SendCode;
      const method = "POST";
      let params = {
        mobile: this.formData.mobile,
        country_code:this.area_code,
        code:this.formData.img_code
      };
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {

        } else {
          console.log("注册");
        }
      });
    },
    changeImgCode(){
      this.getImgCode()
    },
    sendTime() {
      codeTimer = setTimeout(() => {
        if (this.countdown == 1) {
          this.clearCodeTimer();
          return;
        } else {
          this.countdown--;
          this.sendTimeText = "重新发送(" + this.countdown + "s)";
          setTimeout(this.sendTime(), 1000);
        }
      }, 1000);
    },
    //清除定时器
    clearCodeTimer() {
      clearTimeout(codeTimer);
      this.isReSend = true;
      this.sendTimeText = "获取验证码";
      this.countdown = 60;
    },
    //验证表单
    verifyForm() {
      if (!this.verifyMobile()) {
      } else if (this.formData.code == "") {
        common.toast("请输入验证码", 1000);
      } else if(this.formData.img_code=='') {
        return false;
      }else{
        return true
      }
      return false;
    },
    setUserInfo(data){
      localStorage.setItem("userInfo", JSON.stringify(data));
      this.$store.dispatch("storageUserInfo", data);
      let url = this.$route.query.url ? this.$route.query.url : null;
      // let id=this.$route.query.id? this.$route.query.id :null;
      // let meeting_id=this.$route.query.meeting_id? this.$route.query.meeting_id :null;
      // let chapter_id=this.$route.query.chapter_id? this.$route.query.chapter_id :null;
      // let channel_id=this.$route.query.channel_id? this.$route.query.channel_id :null;
      // if(id){
      //   url=url+'&id='+id;
      // }
      // if(meeting_id){
      //   url=url+'&meeting_id='+meeting_id;
      // }
      // if(chapter_id){
      //   url=url+'&chapter_id='+chapter_id;
      // }
      // if(channel_id){
      //   url=url+'&channel_id='+channel_id;
      // }
      if (url) {
        window.location.replace(url);
      } else {
        this.$router.replace({
          path: "/vascularNews",
        });
      }
    },
    //获取用户信息
    getUserInfo() {
      const url = GetUserInfo;
      const method = "POST";
      let params = {};
      fetch(url, params, method)
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            localStorage.setItem("userInfo", JSON.stringify(data));
            this.$store.dispatch("storageUserInfo", data);
            let url = this.$route.query.url ? this.$route.query.url : null;
            if (url) {
              window.location.replace(url);
            } else {
              this.$router.replace({
                path: "/vascularNews",
              });
            }
          }
        })
        .catch(() => {});
    },
  },
  destroyed() {
    this.clearCodeTimer();
  },
};
</script>
<style lang="scss">
.login {
  position: relative;
  width: 100%;
  height: 100%;
  .header {
    padding-top: 100px;
    text-align: center;
    font-size: 18px;
    line-height: 20px;
    img {
      display: block;
      margin: -20px auto 20px;
    }
  }
  .login-form {
    .van-cell-group {
      width: 295px;
      height: 44px;
      box-sizing: border-box;
      margin: 0 auto;
      margin-bottom: 20px;
      @include flex(row);
      align-items: center;
      border-bottom: 1px solid #d3d3d3;
      padding-left: 15px;
      padding-right: 5px;
      .van-cell {
        padding: 0px 10px;
        background: transparent;
        input {
          height: 44px;
        }
        input::-webkit-input-placeholder {
          color: #ababab;
          font-size: 14px;
        }
      }
      img {
        height: 25px;
        vertical-align: middle;
      }
      .left-flag{
        line-height: 25px;
        width:140px;
        display: flex;
        align-items: center;
      }
    }
    .code {
      width: 150px;
      height: 44px;
      color: #901d22;
    }
    .login-button {
      display: block;
      margin: 50px auto;
      width: 295px;
      height: 44px;
      background: #901d22;
      font-size: 17px;
      color: #fff;
      border: 0px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/User/Login.vue